// Must be the FIRST import: patches ResizeObserver before recharts is evaluated.
import './suppressResizeObserverLoop';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Prevent the scroll wheel from changing number input values.
document.addEventListener(
  'wheel',
  (e) => {
    const target = e.target as HTMLElement;
    if (target?.tagName === 'INPUT' && (target as HTMLInputElement).type === 'number') {
      (target as HTMLInputElement).blur();
      e.preventDefault();
    }
  },
  { passive: false },
);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
